<template>
  <div id="mypage_menu">
    <div @click="toggleMenu" id="menu" v-bind:class="{ menuopen: open }">
      <span class="nav-icon-box">
        <!-- ユーザアイコン  -->
        <span v-show="loading">
          <vue-loading
            style="display: inline-block; _display: inline"
            type="spin"
            color="#333"
            :size="{ width: '30px', height: '30px' }"
          ></vue-loading>
        </span>
        <span v-show="!loading">
          <img
            class="small_noicon"
            v-if="!user.icon_name"
            :src="mediaportalResourceUrl + '/community/img/noimg_man@3x.png'"
            alt="デフォルトアイコン"
          />
          <img
            v-else
            class="rounded-circle small_icon"
            :src="user.icon_url"
            :alt="user.name"
          />
          <img
            v-if="countNotifications"
            :src="mediaportalResourceUrl + '/community/img/yellow_circle.png'"
            class="nav-notification"
            alt="通知あり"
          />
        </span>
      </span>

      <span class="nav_item">{{ user.type }}</span>
      <span v-cloak v-if="profile.type == 'プレ花'">
        <img style="vertical-align:middle"
          :src="mediaportalResourceUrl + '/community/img/login1_on.png'"
          alt="アイコン"
        />
        <img style="vertical-align:middle"
          :src="mediaportalResourceUrl + '/community/img/login2_off.png'"
          alt="アイコン"
        />
      </span>
      <span v-cloak v-else-if="profile.type == '卒花'">
        <img style="vertical-align:middle"
          :src="mediaportalResourceUrl + '/community/img/login1_off.png'"
          alt="アイコン"
        />
        <img style="vertical-align:middle"
          :src="mediaportalResourceUrl + '/community/img/login2_on.png'"
          alt="アイコン"
        />
      </span>
    </div>
    <div
      id="mypage_background"
      @click="toggleMenu"
      :class="{ background_open: open }"
    ></div>
    <div
      class="justify-content-center"
      id="mypage_wrapper"
      :class="{ list_open: open }"
    >
      <div class="profile" id="mypage_list">
        <div class="card">
          <div
            class="card-header light-pink-header position-relative text-center"
          >
            <span id="mypage_close_button" @click="toggleMenu">
              <img
                :src="
                  mediaportalResourceUrl + '/community/img/btn_close_white.png'
                "
                style="cursor: pointer"
                alt="閉じる"
              />
            </span>
            <span> マイページ </span>
          </div>

          <div class="card-body p-3">
            <div>
              <vue-loading
                v-show="loading"
                type="spin"
                color="#333"
                :size="{ width: '100px', height: '100px' }"
              ></vue-loading>
            </div>

            <div v-show="!loading" class="mt-2">
              <div class="container-fluid pr-0 pl-0">
                <div class="row w-100">
                  <small class="col-5 text-center p-0">
                    <img
                      v-if="!user.icon_name"
                      :src="
                        mediaportalResourceUrl +
                        '/community/img/noimg_man@3x.png'
                      "
                      class="middle_noicon"
                      alt="デフォルトアイコン"
                    />
                    <img
                      v-else
                      id="nav_icon"
                      class="nav_item middle_icon"
                      :src="user.icon_url"
                      :alt="user.name"
                    />
                    <br />
                    {{ user.name }}<br />
                    ({{ user.ID }})<br />
                    <!-- regionがnullableの場合 -->
                    {{ user.type }}
                    <span v-if="profile.region"
                      >|&nbsp; {{ profile.region }}
                    </span>
                    &nbsp;|&nbsp;{{ user.age }}歳
                  </small>
                  <div class="col-7 text-center">
                    <table class="ml-auto mr-auto followbox w-90">
                      <tr>
                        <td class="right-dot p-1">
                          フォロワー <br />
                          <img
                            :src="
                              mediaportalResourceUrl +
                              '/community/img/icon_follower@3x.png'
                            "
                            class="extra_small_icon"
                            alt="フォロワー"
                          />
                          {{ follower }}
                        </td>
                        <td class="p-1 right-content">
                          フォロー中<br />
                          <img
                            :src="
                              mediaportalResourceUrl +
                              '/community/img/icon_follow@3x.png'
                            "
                            class="extra_small_wide_icon"
                            alt="フォロー中"
                          />
                          {{ following }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" class="text-left" style="text-align:left!important;">
                          {{ profile.introduction || "" }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="!loading" class="justify-content-center mt-4">
              <div>
                <table
                  class="table ml-auto mr-auto text-center"
                  style="table-layout: fixed"
                >
                  <tr>
                    <td class="col-xs-5 right-dot p-1">
                      <img
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/icon_tw1@2x.png'
                        "
                        alt="Twitter"
                      /><br /><br />
                      <span v-if="profile.Twitter"
                        ><a
                          :href="twitter_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ profile.Twitter }}</a
                        ></span
                      >
                      <span v-else>未登録</span>
                    </td>
                    <td class="col-xs-2 right-dot p-1">
                      <img
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/glyph-logo_May2016@2x.png'
                        "
                        alt="Instagram"
                      /><br /><br />
                      <span v-if="profile.Instagram"
                        ><a
                          :href="instagram_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ profile.Instagram }}</a
                        ></span
                      >
                      <span v-else>未登録</span>
                    </td>
                    <td class="col-xs-5 p-1 profile-no-border right-content">
                      <img
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/icon_youtube@3x.png'
                        "
                        alt="Youtube"
                        style="max-height: 40px"
                      /><br /><br />
                      <span v-if="profile.Youtube"
                        ><a
                          :href="Youtube_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ profile.Youtube }}</a
                        ></span
                      >
                      <span v-else>未登録</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="text-center container-fluid pr-0 pl-0">
              <div class="row w-100">
                <div
                  class="card mr-auto pr-auto p-1 small-font pb-2"
                  style="width: 49%"
                >
                  <table class="w-100">
                    <tr>
                      <td>
                        <div class="icon-text">
                          <img
                            class="p-1"
                            :src="
                              mediaportalResourceUrl +
                              '/community/img/login1_on@2x.png'
                            "
                            alt="挙式会場"
                          />
                          <b class="align-bottom pink-font">挙式会場</b>
                        </div>
                      </td>
                    </tr>
                    <tr v-show="profile.wedding_hall">
                      <td>{{ profile.wedding_hall }}</td>
                    </tr>
                    <tr v-show="profile.wedding_date">
                      <td>挙式日:{{ profile.wedding_date }}</td>
                    </tr>
                    <tr v-show="profile.wedding_area">
                      <td>| {{ profile.wedding_area }} |</td>
                    </tr>
                  </table>
                </div>
                <div class="card p-1 small-font pb-2" style="width: 49%">
                  <table class="w-100">
                    <tr>
                      <td>
                        <div class="icon-text">
                          <img
                            class="p-1"
                            :src="
                              mediaportalResourceUrl +
                              '/community/img/login2_on@2x.png'
                            "
                            alt="披露宴会場"
                          />
                          <b class="align-bottom pink-font">披露宴会場</b>
                        </div>
                      </td>
                    </tr>
                    <tr v-show="profile.reception_hall">
                      <td>{{ profile.reception_hall }}</td>
                    </tr>
                    <tr v-show="profile.reception_date">
                      <td>披露宴日:{{ profile.reception_date }}</td>
                    </tr>
                    <tr v-show="profile.reception_area">
                      <td>| {{ profile.reception_area }} |</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

            <div
              v-if="
                user.countdown > 10 &&
                (profile.wedding_plan == 1 || profile.reception_plan == 1)
              "
              class="card text-center mt-2 p-1 bg-pink"
            >
              <table class="table table-layout-fixed mb-0 table-borderless" style="table-layout:fixed">
                <tr>
                  <td colspan="3" class="p-0">式まであと</td>
                </tr>
                <tr>
                  <td class="col-4 align-middle">
                    <img
                      :src="
                        mediaportalResourceUrl +
                        '/community/img/maypage_calender.png'
                      "
                      alt=""
                    />
                  </td>
                  <td class="col-4 h2 align-middle mypage-pink-text">
                    {{ user.countdown }}
                  </td>
                  <td class="col-4 align-middle">
                    <img
                      :src="
                        mediaportalResourceUrl +
                        '/community/img/mypage_days@2x.png'
                      "
                      alt="DAYS"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-else-if="
                user.countdown > 0 &&
                (profile.wedding_plan == 1 || profile.reception_plan == 1)
              "
              class="mt-2"
            >
              <img
                :src="
                  '/community/img/calendar_' + user.countdown + 'days@3x.png'
                "
                :alt="'挙式まで' + user.countdown + '日'"
              />
            </div>
            <div
              v-else-if="
                user.countdown == 0 &&
                (profile.wedding_plan == 1 || profile.reception_plan == 1)
              "
              class="mt-2"
            >
              <img
                :src="'/community/img/calendar_goal@3x.png'"
                alt="Happy Wedding"
              />
            </div>

            <a
              :href="`/user/${user.ID}/notifications?from=blog`"
              style="color: #333333; text-decoration: none"
            >
              <div
                class="card text-center mt-2 bg-pink notification-link align-middle"
              >
                <span
                  v-show="countNotifications > 0"
                  class="circle-notification yellow-mark"
                >
                  {{ countNotifications }}
                </span>
                <span class="text mypage-pink-text">お知らせ</span>
              </div>
            </a>

            <div class="card mt-4">
              <table
                class="table table-light text-center ml-auto mr-auto latticle"
              >
                <tr>
                  <td>
                    <a
                      :href="
                        communicationUrl + `/user/edit_profile/step7?from=blog`
                      "
                      style="color: #333333"
                      ><img
                        class="mypage_icon"
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/maypage_icon1.png'
                        "
                        alt="プロフィール"
                      /><br />プロフィール<br />編集</a
                    >
                  </td>
                  <td>
                    <a
                      :href="
                        communicationUrl + `/user/${user.ID}/my_story?from=blog`
                      "
                      style="color: #333333"
                      ><img
                        class="mypage_icon"
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/mypage_icon2.png'
                        "
                        alt="マイストーリー"
                        style="margin-bottom: 2px"
                      /><br />あなたの<br />ウェディング<br />ストーリー</a
                    >
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      :href="
                        communicationUrl +
                        `/user/${user.ID}/my_review?from=blog`
                      "
                      style="color: #333333"
                      ><img
                        class="mypage_icon"
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/maypage_icon3.png'
                        "
                        alt="マイクチコミ"
                      /><br />あなたの<br />クチコミ</a
                    >
                  </td>
                  <td>
                    <a
                      :href="
                        communicationUrl + `/user/${user.ID}/my_bbs?from=blog`
                      "
                      style="color: #333333"
                      ><img
                        class="mypage_icon"
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/maypage_icon4.png'
                        "
                        alt="マイ掲示板"
                      /><br />あなたの<br />掲示板</a
                    >
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      :href="
                        communicationUrl +
                        `/user/${user.ID}/my_follows?from=blog`
                      "
                      style="color: #333333"
                      ><img
                        class="mypage_icon"
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/maypage_icon5.png'
                        "
                        alt="フォロー一覧"
                      /><br />フォロー<br />一覧</a
                    >
                  </td>
                  <td>
                    <a
                      :href="
                        communicationUrl +
                        `/user/${user.ID}/my_followers?from=blog`
                      "
                      style="color: #333333"
                      ><img
                        class="mypage_icon"
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/maypage_icon6.png'
                        "
                        alt="フォロワー一覧"
                      /><br />フォロワー<br />一覧</a
                    >
                  </td>
                </tr>
              </table>
            </div>

            <!-- <div class="card text-center mt-4 p-4 border-text-pink">
                            ログアウト
                        </div> -->
            <button
              @click="openModal"
              class="text-center mt-4 mb-4 p-4 col-12 border-text-pink"
            >
              ログアウト
            </button>

            <!-- コンポーネント MyModal -->
            <LogoutModal @close="closeModal" v-if="modal">
              <!-- default スロットコンテンツ -->
              <p class="mypage_logout_message">ログアウトしますか？</p>
              <button class="mypage_logout_button" @click="logout">
                ログアウトする
              </button>
              <!-- /default -->
              <!-- footer スロットコンテンツ -->
              <template slot="footer"> </template>
              <!-- /footer -->
            </LogoutModal>
          </div>
        </div>
      </div>
      <!-- </div>s -->
    </div>
  </div>
</template>

<script>
import LogoutModal from "./LogoutModal.vue";
import { VueLoading } from "vue-loading-template";
import axios from "axios";

export default {
  beforeDestroy() {
    document.body.className = "";
    this.$root.headerHide = false;
    this.$root.footerHide = false;
  },
  components: {
    LogoutModal,
    VueLoading,
  },
  computed: {
    //外部リンク用のURL
    twitter_link() {
      return "https://twitter.com/" + this.profile.Twitter;
    },
    instagram_link() {
      return "https://www.instagram.com/" + this.profile.Instagram;
    },
    Youtube_link() {
      return "https://www.youtube.com/channel/" + this.profile.Youtube;
    },
    communicationUrl: function () {
      return process.env.VUE_APP_BASE_COMMUNICATION_URL;
    },
    mediaportalResourceUrl: function () {
      return (
        process.env.VUE_APP_BASE_MEDIAPORTAL_URL +
        process.env.VUE_APP_MEDIAPORTAL_RESOURCE_URI
      );
    },
  },
  data() {
    return {
      open: false,
      follower: "",
      following: "",
      user: {},
      profile: {},
      separate: "",
      countNotifications: 0,
      modal: false,
      loading: true,
      offset: 0,
    };
  },
  mounted() {
    //ユーザのフォロー、フォロワー数の取得
    axios
      .get(process.env.VUE_APP_BASE_COMMUNICATION_URL + "/api/follows_count")
      .then((response) => {
        this.following = response.data.follow;
        this.follower = response.data.followed;
      });
    //ユーザのプロフィール情報の取得
    axios
      .get(process.env.VUE_APP_BASE_COMMUNICATION_URL + "/api/mypage", {
        timeout: 30000,
      })
      .then((response) => {
        this.profile = response.data.profile;
        this.user = response.data.user;
        this.loading = false;
      })
      .catch((error) => {
        alert(
          "ユーザー情報の読み込みに失敗しました。\n再読み込みしていただくか、再ログインをお願いします。"
        );
        this.loading = false;
      });

    // 通知件数の取得;
    axios
      .get(
        process.env.VUE_APP_BASE_COMMUNICATION_URL + "/api/countNotifications"
      )
      .then((response) => (this.countNotifications = response.data));

    this.user.icon_url =
      this.mediaportalResourceUri + "/community/img/noimg_man@2x.png";
    // console.log(this.user.icon_url)
  },
  methods: {
    async toggleMenu() {
      console.log("toggleMenu");
      var bg = document.getElementById("mypage_background");
      var wrapper = document.getElementById("mypage_wrapper");
      // var main = document.getElementsByTagName("main")[0];
      // var footer = document.getElementsByTagName("footer")[0];

      if (!bg.classList.contains("background_open")) {
        this.offset = window.pageYOffset;
        // main.style.top = -this.offset + "px";
        // footer.style.top = -(this.offset - main.scrollHeight) + "px";
        bg.style.display = "block";
        wrapper.style.display = "block";
        wrapper.style.height = "100vh";
        wrapper.style.overflowY = "scroll";
        // main.style.position = "fixed";
        // footer.style.position = "fixed";
        // this.$store.commit("path/setPath", this.$route.path);

        // 開くアニメーションのため時間差実行
        setTimeout(function () {
          bg.classList.add("background_open");
          wrapper.classList.add("list_open");
          //                    this.open = true; // 時間差実行だとvueのopen変数が何故かtrueとならないため不採用
        }, 1);
      } else {
        bg.classList.remove("background_open");
        wrapper.classList.remove("list_open");
        bg.style.display = "none";
        wrapper.style.display = "none";
        // main.style.position = "static";
        // footer.style.position = "static";
        document.documentElement.scrollTop = this.offset;
        //                    this.open = false
      }
    },
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    async logout() {
      await this.$store.dispatch("auth/logout");
      // ログアウト後にページリロード
      window.location.href = this.communicationUrl + "/user/sign_in";
    },
    change_loading() {
      this.loading = false;
    },
  },

  watch: {
    $route: {
      async handler() {
        //通知件数の取得
        axios
          .get(
            process.env.VUE_APP_BASE_COMMUNICATION_URL +
              "/api/countNotifications"
          )
          .then((response) => (this.countNotifications = response.data));
      },
      immediate: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ModalMypage.vue